/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import OrderLineItemResultModel from './OrderLineItemResultModel';

/**
* The PreviewOrderResultModel model module.
* @module model/PreviewOrderResultModel
* @version 1.0.0
*/
export default class PreviewOrderResultModel {
    /**
    * Constructs a new <code>PreviewOrderResultModel</code>.
    * @alias module:model/PreviewOrderResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>PreviewOrderResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/PreviewOrderResultModel} obj Optional instance to populate.
    * @return {module:model/PreviewOrderResultModel} The populated <code>PreviewOrderResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PreviewOrderResultModel();
                        
            
            if (data.hasOwnProperty('GrandTotal')) {
                obj['GrandTotal'] = ApiClient.convertToType(data['GrandTotal'], 'Number');
            }
            if (data.hasOwnProperty('TotalTaxes')) {
                obj['TotalTaxes'] = ApiClient.convertToType(data['TotalTaxes'], 'Number');
            }
            if (data.hasOwnProperty('TotalDiscounts')) {
                obj['TotalDiscounts'] = ApiClient.convertToType(data['TotalDiscounts'], 'Number');
            }
            if (data.hasOwnProperty('TotalTips')) {
                obj['TotalTips'] = ApiClient.convertToType(data['TotalTips'], 'Number');
            }
            if (data.hasOwnProperty('SubTotal')) {
                obj['SubTotal'] = ApiClient.convertToType(data['SubTotal'], 'Number');
            }
            if (data.hasOwnProperty('LineItems')) {
                obj['LineItems'] = ApiClient.convertToType(data['LineItems'], [OrderLineItemResultModel]);
            }
        }
        return obj;
    }

    /**
    * @member {Number} GrandTotal
    */
    'GrandTotal' = undefined;
    /**
    * @member {Number} TotalTaxes
    */
    'TotalTaxes' = undefined;
    /**
    * @member {Number} TotalDiscounts
    */
    'TotalDiscounts' = undefined;
    /**
    * @member {Number} TotalTips
    */
    'TotalTips' = undefined;
    /**
    * @member {Number} SubTotal
    */
    'SubTotal' = undefined;
    /**
    * @member {Array.<module:model/OrderLineItemResultModel>} LineItems
    */
    'LineItems' = undefined;




}
